module.exports = __webpack_public_path__ + "assets/1-sales-manager-job-description.e1662412.png";